module.exports = __webpack_public_path__ + "static/media/image-card-4.5205a8d5.png";